/**
 * Role V2 Repository - GraphQL Queries
 *
 * 7 query operations for Role primitive data access.
 * All queries use ROLE_FIELDS_FRAGMENT for consistency.
 */

import { gql } from '@apollo/client';
import { ROLE_FIELDS_FRAGMENT } from './fragments';

export const GET_ROLE = gql`
  ${ROLE_FIELDS_FRAGMENT}
  query GetRole($tenantId: String!, $roleId: String!) {
    getRole(tenantId: $tenantId, roleId: $roleId) {
      ...RoleFields
    }
  }
`;

export const LIST_ROLES = gql`
  ${ROLE_FIELDS_FRAGMENT}
  query ListRoles($tenantId: String!, $limit: Int, $cursor: String) {
    listRoles(tenantId: $tenantId, limit: $limit, cursor: $cursor) {
      items {
        ...RoleFields
      }
      nextCursor
      hasMore
    }
  }
`;

export const LIST_ROLES_BY_CATEGORY = gql`
  ${ROLE_FIELDS_FRAGMENT}
  query ListRolesByCategory($tenantId: String!, $category: RoleCategory!, $limit: Int, $cursor: String) {
    listRolesByCategory(tenantId: $tenantId, category: $category, limit: $limit, cursor: $cursor) {
      items {
        ...RoleFields
      }
      nextCursor
      hasMore
    }
  }
`;

export const GET_ROLE_HIERARCHY = gql`
  ${ROLE_FIELDS_FRAGMENT}
  query GetRoleHierarchy($tenantId: String!, $roleId: String!) {
    getRoleHierarchy(tenantId: $tenantId, roleId: $roleId) {
      role {
        ...RoleFields
      }
      parents {
        ...RoleFields
      }
      children {
        ...RoleFields
      }
      effectivePermissions {
        permissionId
        scope
        actions
        constraints {
          constraintType
          value
        }
      }
    }
  }
`;

export const LIST_ACTIVE_ROLES = gql`
  ${ROLE_FIELDS_FRAGMENT}
  query ListActiveRoles($limit: Int, $cursor: String) {
    listActiveRoles(limit: $limit, cursor: $cursor) {
      items {
        ...RoleFields
      }
      nextCursor
      hasMore
    }
  }
`;

export const VALIDATE_PERMISSION = gql`
  query ValidatePermission(
    $tenantId: String!
    $roleIds: [String!]!
    $action: String!
    $resourceType: String!
    $resourceId: String!
  ) {
    validatePermission(
      tenantId: $tenantId
      roleIds: $roleIds
      action: $action
      resourceType: $resourceType
      resourceId: $resourceId
    ) {
      allowed
      reason
      matchedRoles
      constraints {
        constraintType
        value
      }
    }
  }
`;

export const GET_ROLE_PERMISSIONS = gql`
  query GetRolePermissions($tenantId: String!, $roleId: String!, $includeInherited: Boolean!) {
    getRolePermissions(tenantId: $tenantId, roleId: $roleId, includeInherited: $includeInherited) {
      permissionId
      scope
      actions
      constraints {
        constraintType
        value
      }
    }
  }
`;
